module.exports = __webpack_public_path__ + "static/assets/bbf2d5fafa90828ea009f714d0e645ae.svg";